<template>
  <EditableArea
    v-if="footer && Object.keys(footer).length"
    :content="footer"
  />
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';
import { useSSR } from '~/composables/useSSR/useSSR';

const { getFooter, footer } = usePageLoader('footer-inherited');
const { onSSR } = useSSR();

onSSR(async () => {
  if (footer.value) {
    return;
  }

  await getFooter();
});
</script>
